/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { AviBackendErrorMsgPipe } from 'nsx-alb-ui-components';

angular.module('avi/app').filter(
    'aviBackendErrorMsg', () => AviBackendErrorMsgPipe.aviBackendErrorMsg,
);
